class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');
    this.querySelectorAll('button[type="button"]').forEach(button => button.addEventListener('click', () => this.close()));
    this.notification.addEventListener('pointerenter', () => this.pause());
    this.notification.addEventListener('focusin', () => this.pause());
    this.notification.addEventListener('pointerleave', () => this.schedule());
    this.notification.addEventListener('focusout', () => requestAnimationFrame(() => this.schedule()));
    this.positionHandler = () => {
      cancelAnimationFrame(this.positionFrame);
      this.positionFrame = requestAnimationFrame(() => this.positionNotification());
    };
    this.escapeHandler = event => { if (event.key === 'Escape') this.close(); };
  }
  pause() { clearTimeout(this.dismissTimer); }
  schedule() {
    this.pause();
    if (!this.notification.classList.contains('active') || this.notification.matches(':hover') || this.notification.contains(document.activeElement)) return;
    this.dismissTimer = setTimeout(() => this.close(), 8000);
  }
  positionNotification() {
    const icon = document.getElementById('cart-icon-bubble');
    const rect = icon?.getBoundingClientRect();
    const margin = 12;
    const viewportWidth = document.documentElement.clientWidth;
    const width = Math.min(410, viewportWidth - margin * 2);
    this.notification.style.setProperty('--tth-confirm-width', width + 'px');
    const visible = rect && rect.bottom > 0 && rect.top < window.innerHeight;
    const right = visible ? Math.max(margin, Math.min(viewportWidth - width - margin, viewportWidth - rect.right)) : margin;
    const top = visible ? Math.max(margin, Math.min(rect.bottom + 10, window.innerHeight - 120)) : margin;
    const anchor = visible ? Math.max(20, Math.min(width - 20, rect.left + rect.width / 2 - (viewportWidth - right - width))) : width - 28;
    this.notification.style.setProperty('--tth-confirm-top', top + 'px');
    this.notification.style.setProperty('--tth-confirm-right', right + 'px');
    this.notification.style.setProperty('--tth-confirm-anchor', anchor + 'px');
  }
  open() {
    if (this.parentElement !== document.body) document.body.append(this);
    this.positionNotification();
    this.confirmationIcon = document.getElementById('cart-icon-bubble');
    this.confirmationIcon?.classList.add('tth-cart-confirming');
    this.notification.classList.add('animate', 'active');
    window.addEventListener('resize', this.positionHandler);
    window.addEventListener('scroll', this.positionHandler, {passive:true});
    this.notification.setAttribute('aria-hidden', 'false');
    this.classList.add('tth-confirmation-open');
    const status = this.querySelector('[data-cart-status]');
    const productName = this.querySelector('.cart-notification-product__name'); const title = productName?.getAttribute('aria-label') || productName?.textContent.trim() || 'Item';
    if (status) status.textContent = title + ' added to your cart.';
    document.addEventListener('keydown', this.escapeHandler);
    this.schedule();
  }
  close() {
    const focusInside = this.notification.contains(document.activeElement);
    this.pause();
    cancelAnimationFrame(this.positionFrame);
    window.removeEventListener('resize', this.positionHandler);
    window.removeEventListener('scroll', this.positionHandler);
    this.confirmationIcon?.classList.remove('tth-cart-confirming');
    this.notification.classList.remove('active');
    this.notification.setAttribute('aria-hidden', 'true');
    this.classList.remove('tth-confirmation-open');
    document.removeEventListener('keydown', this.escapeHandler);
    if (focusInside && this.activeElement?.isConnected) this.activeElement.focus({preventScroll:true});
  }
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      const current = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];
      if (current && html) current.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });
    this.open();
  }
  getSectionsToRender() {
    return [
      {id:'cart-notification-product', selector:'#cart-notification-product-' + this.productId},
      {id:'cart-notification-button'},
      {id:'cart-icon-bubble'}
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html,'text/html').querySelector(selector)?.innerHTML || '';
  }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-notification', CartNotification);
